import { render } from "./workload.vue?vue&type=template&id=02bc00c4"
import script from "./workload.vue?vue&type=script&lang=js"
export * from "./workload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__